import { DATE_FORMATS } from 'constants/date';
import {
  REMINDER_RANGE_FIELD_KEYS,
  REMINDER_RANGE_SUPPORTED_FREQUENCIES,
  REMINDER_TYPES,
} from 'constants/reminders';
import { formatMonthDay } from 'utils/date';

export function hasSeasonalRange(schedule = {}) {
  return REMINDER_RANGE_FIELD_KEYS.every(
    (key) => schedule?.[key] !== null && schedule?.[key] !== undefined
  );
}

export function formatSeasonalRange(
  rangeStartMonth,
  rangeStartDay,
  rangeEndMonth,
  rangeEndDay,
  dateFormat = DATE_FORMATS.MM_DD_YYYY
) {
  const startLabel = formatMonthDay(rangeStartMonth, rangeStartDay, dateFormat);
  const endLabel = formatMonthDay(rangeEndMonth, rangeEndDay, dateFormat);

  if (!startLabel || !endLabel) {
    return null;
  }

  return `${startLabel} - ${endLabel}`;
}

export function formatReminderActiveWindow(data, settings = {}) {
  const { type, frequency, schedule } = data || {};

  if (
    type !== REMINDER_TYPES.REPEATING
    || !REMINDER_RANGE_SUPPORTED_FREQUENCIES.includes(frequency)
    || !hasSeasonalRange(schedule)
  ) {
    return null;
  }

  const formattedRange = formatSeasonalRange(
    schedule?.rangeStartMonth,
    schedule?.rangeStartDay,
    schedule?.rangeEndMonth,
    schedule?.rangeEndDay,
    settings?.dateFormat,
  );

  return formattedRange ? `Active window: ${formattedRange}` : null;
}
